export default __webpack_public_path__ + "static/media/busz-felirat.df7d0995.png";